<template>
  <div class="nk-box-title today-alarm">
    <div class="title-content dn-title-bg">
      <div class="title-content-left">
        <i :class="iconClass" class="logoico"></i>
        <label class="logotitle">{{title}}</label>
      </div>
      <div class="title-content-right">
        <slot name="title"></slot>
      </div>
    </div>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "NkBoxTitle",
  props: {
    iconClass: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "标题"
    }
  },
  data() {
    return {};
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.nk-box-title {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  border-radius: 4px;
  -webkit-transform: translateZ(0);
  -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);
  .content {
        display: flex;
        flex: 1;
        // overflow: auto;
        border-radius: 0 0 4px 4px;
  }
}
.title-content {
  display: flex;
  padding: 0px 8px;
  align-items: center;
  height: 38px;
  line-height: 38px;
  .title-content-left {
    flex: 1;
    color: #fff;
    text-align: left;
    .logoico{
        font-size: 20px;
    }
    .logotitle{
        font-size: 17px;
        font-weight: 600;
        margin-left: 5px;
        color: #fff;
    }
  }
  .title-content-right{
    height: 38px;
    color: #fff;
    background: rgba(241, 242, 244);
  }
}
</style>